// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family:
    "Graphik",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.App {
  width: 100%;
  min-height: 100vh;
}

/* Compass category fade-in animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeInUp {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* LJ PDP: Add to cart pink + sparkle */
@keyframes atcSparkle {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  40% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.atc-button-sparkle {
  position: absolute;
  pointer-events: none;
  animation: atcSparkle 0.6s ease-out forwards;
}

.atc-button-pink {
  background-color: #ec4899 !important;
  transition: background-color 0.25s ease-out;
}

/* Brand-funded promo: explicit 6-column product grid (responsive utilities sometimes stayed at 3 cols) */
.product-grid-six {
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (min-width: 640px) and (max-width: 767px) {
  .product-grid-six {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {
  .product-grid-six {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;;;;cAYY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA,yGAAyG;AACzG;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":["body {\n  font-family:\n    \"Graphik\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.App {\n  width: 100%;\n  min-height: 100vh;\n}\n\n/* Compass category fade-in animation */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fadeInUp {\n  animation: fadeInUp 0.5s ease-out;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* LJ PDP: Add to cart pink + sparkle */\n@keyframes atcSparkle {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n  40% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n\n.atc-button-sparkle {\n  position: absolute;\n  pointer-events: none;\n  animation: atcSparkle 0.6s ease-out forwards;\n}\n\n.atc-button-pink {\n  background-color: #ec4899 !important;\n  transition: background-color 0.25s ease-out;\n}\n\n/* Brand-funded promo: explicit 6-column product grid (responsive utilities sometimes stayed at 3 cols) */\n.product-grid-six {\n  display: grid;\n  justify-items: center;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n@media (min-width: 640px) and (max-width: 767px) {\n  .product-grid-six {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .product-grid-six {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
